import { render, staticRenderFns } from "./FISS_Department.vue?vue&type=template&id=67aa68ac&scoped=true&"
var script = {}
import style0 from "./FISS_Department.vue?vue&type=style&index=0&id=67aa68ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67aa68ac",
  null
  
)

export default component.exports